/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClassificationItem } from './classificationItem';
import { GradeBookClassificationStatusEnum } from './gradeBookClassificationStatusEnum';
import { NullEnum } from './nullEnum';

/**
 * The AI suggestion and the confirmed classification of one Třídnice record (POR-001 §6).
 */
export interface GradeBookClassification { 
    /**
     * False when the backend has no Gemini key (AI suggestion is off).
     */
    enabled: boolean;
    status: GradeBookClassificationStatusEnum | NullEnum;
    readonly suggested: Array<ClassificationItem>;
    readonly confirmed: Array<ClassificationItem>;
    reasoning: string;
    error: string;
    analyzedAt: Date;
    confirmedAt: Date;
    confirmedByName: string;
}